module.exports = __webpack_public_path__ + "h5/img/02@2x.cf9e857a.png";